import React from 'react';
import styled from '@emotion/styled';
import { Chip } from "@material-ui/core";
import { Tag } from './useTagManagement';

interface Props {
    tag: Tag;
    wrap?: boolean;
}

export const ChipTextWrap = styled.div`
    overflow: hidden;
    height: auto;
    min-height: 1em;
    padding: 4px;
    & > .MuiChip-label {
        white-space: break-spaces;
        text-align: center;
    }
`;

export const TagDisplay = ({ tag, wrap }: Props) => {
    return <Chip key={tag._id} label={tag.label} component={wrap ? ChipTextWrap : "div"} />;
}


const TagsWrapper = styled.div`
    display: flex;
    flex-flow: row wrap;
    gap: 0.5rem;
    cursor: ${props => props.onClick ? 'pointer' : undefined};

    & > * {
        cursor: ${props => props.onClick ? 'pointer' : undefined};
    }
`;

interface TagsProps {
    tags: Tag[];
    canEdit?: boolean;
    onClick?: () => void;
    remove?: (t: Tag) => void;
    wrap?: boolean;
}

export const TagsDisplay = (props: TagsProps) => {
    const { tags, onClick, remove } = props;
    return <TagsWrapper onClick={onClick}>
        {tags.map(t => (
            <Chip
                key={t._id}
                label={t.label}
                onDelete={remove ? () => remove(t) : undefined}
                component={props.wrap ? ChipTextWrap : "div"}
                />))}
    </TagsWrapper>
}
